
//Check jQuery exist
if (!window.jQuery) {
  var head = document.head;
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.onload = function () {
    init();
  };
  script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js';
  head.appendChild(script);
} else {
  init();
}

function init() {
  jQuery(document).ready(function ($) {
    //Support accounts are required
    var sfCheckoutLink = getCookie('sfCheckoutLink');

    if (sfCheckoutLink != null && sfCheckoutLink != "undefined") {
      var returnTo = '<input type="hidden" name="return_to" value="' + sfCheckoutLink + '" />';

      //Update checkout_url in login page
      var checkoutUrl = $("input[value='customer_login']").parent().find('input[name="checkout_url"]');

      if (checkoutUrl.length) {
        //check login checkout url include "checkout" text
        var checkLoginCheckoutUrl = checkoutUrl.val().includes("checkout");

        if (checkLoginCheckoutUrl) {
          var newLoginFormCheckoutUrl = checkoutUrl.val() + sfCheckoutLink.replace("/checkout?", "&");
          checkoutUrl.val(newLoginFormCheckoutUrl);
        }
      }

      //Add return_to in recaptcha page
      var recReturnUrl = $("#g-recaptcha").parent().find('input[name="return_to"]');

      if ($('#g-recaptcha').length) {
        if (recReturnUrl.length > 0) {
          recReturnUrl.val(sfCheckoutLink);
        } else {
          $("#g-recaptcha").parent().append(returnTo);
        }
      }

      updateAccountForm();

      //When form updated
      $('form').on('DOMSubtreeModified', function () {
        updateAccountForm();
      });
    }

    function updateAccountForm() {
      //Add return_to input in registration form
      var returnUrl = $("input[value='create_customer']").parent().find('input[name="return_to"]');

      if ($("input[value='create_customer']").length) {
        if (returnUrl.length) {
          returnUrl.val(sfCheckoutLink);
        } else {
          $("input[value='create_customer']").parent().append(returnTo);
        }
      }
    }

    var store = 'oup-shop.myshopify.com';
    var site_url = 'https://shop.ysd.hk/apps/sfexpress';
    var showSfBtn = false;
    var data = null;

    var checkout_btn_bg_color = '#3f4eae';
    var checkout_btn_text_color = '#ffffff';
    var app_description_en = '';
    var app_description_tc = '';
    var ship_address_en = '';
    var ship_address_tc = '';
    var sfexpress_stores_en = '';
    var sfexpress_stores_tc = '';
    var store_pickup_en = '';
    var store_pickup_tc = '';

    if(window.location.href.indexOf('oup-shop-2025.myshopify.com') > -1) {
      store = 'oup-shop-2025.myshopify.com';
    }

    console.log('store', store);

    var sfexpress_copy_en = '';
    var sfexpress_copy_tc = '';
    var sfexpress_copy_font_size = '0';
    var sfexpress_remark_en = '';
    var sfexpress_remark_tc = '';
    var default_sfexpress_copy_en = 'The system has copied the selected address, if it is not brought to the next Checkout page, you could paste in the address field.';
    var default_sfexpress_copy_tc = '如果地址無法自動填寫，請「貼上」到送貨地址欄中（系統已自動替你複製以上所選的地址），或回到購物車頁面再次選擇送貨方式。';

    var pathArray = window.location.pathname.split('/');
    var secondLevelLocation = pathArray[1];
    secondLevelLocation = secondLevelLocation.toLowerCase();

    var checkCurrentLang = '';
    var currentLang = document.getElementsByTagName('html')[0].getAttribute('lang');
    if (currentLang) {
      currentLang = currentLang.toLowerCase();
      checkCurrentLang = currentLang;
    } else {
      checkCurrentLang = 'en';
    }

    // Check site is multi language and set language path
    var langpath = setLangPath(secondLevelLocation);

    if ($('html').is(':lang(zh-TW)')) {
      var lang = 'zh-TW';
      var region = 'region_tc';
      var m1 = '送貨到指定地址';
      var m2 = '前往結帳';
      var m3 = '順豐提貨（順豐站、順便智能櫃或便利店）';
      var m4 = '返回購物車';
      var m5 = '營業時間';
      var m6 = '';
      var m7 = '門市提貨';
      var m8 = '請選擇送貨方式';
      var m9 = '搜尋';
      var all_stores = '所有門市';
    } else if ($('html').is(':lang(zh-HK)')) {
      var lang = 'zh-TW';
      var region = 'region_tc';
      var m1 = '送貨到指定地址';
      var m2 = '前往結帳';
      var m3 = '順豐提貨（順豐站、順便智能櫃或便利店）';
      var m4 = '返回購物車';
      var m5 = '營業時間';
      var m6 = '';
      var m7 = '門市提貨';
      var m8 = '請選擇送貨方式';
      var m9 = '搜尋';
      var all_stores = '所有門市';
    } else if ($('html').is(':lang(zh-CN)')) {
      var lang = 'zh-TW';
      var region = 'region_tc';
      var m1 = '送貨到指定地址';
      var m2 = '前往結帳';
      var m3 = '順豐提貨（順豐站、順便智能櫃或便利店）';
      var m4 = '返回購物車';
      var m5 = '營業時間';
      var m6 = '';
      var m7 = '門市提貨';
      var m8 = '請選擇送貨方式';
      var m9 = '搜尋';
      var all_stores = '所有門市';
    } else if (checkCurrentLang.indexOf('zh') >= 0) {
      var lang = 'zh-TW';
      var region = 'region_tc';
      var m1 = '送貨到指定地址';
      var m2 = '前往結帳';
      var m3 = '順豐提貨（順豐站、順便智能櫃或便利店）';
      var m4 = '返回購物車';
      var m5 = '營業時間';
      var m6 = '';
      var m7 = '門市提貨';
      var m8 = '請選擇送貨方式';
      var m9 = '搜尋';
      var all_stores = '所有門市';
    } else if (checkCurrentLang.indexOf('tw') >= 0) {
      var lang = 'zh-TW';
      var region = 'region_tc';
      var m1 = '送貨到指定地址';
      var m2 = '前往結帳';
      var m3 = '順豐提貨（順豐站、順便智能櫃或便利店）';
      var m4 = '返回購物車';
      var m5 = '營業時間';
      var m6 = '';
      var m7 = '門市提貨';
      var m8 = '請選擇送貨方式';
      var m9 = '搜尋';
      var all_stores = '所有門市';
    } else if (checkCurrentLang.indexOf('hk') >= 0) {
      var lang = 'zh-TW';
      var region = 'region_tc';
      var m1 = '送貨到指定地址';
      var m2 = '前往結帳';
      var m3 = '順豐提貨（順豐站、順便智能櫃或便利店）';
      var m4 = '返回購物車';
      var m5 = '營業時間';
      var m6 = '';
      var m7 = '門市提貨';
      var m8 = '請選擇送貨方式';
      var m9 = '搜尋';
      var all_stores = '所有門市';
    } else if (checkCurrentLang.indexOf('cn') >= 0) {
      var lang = 'zh-TW';
      var region = 'region_tc';
      var m1 = '送貨到指定地址';
      var m2 = '前往結帳';
      var m3 = '順豐提貨（順豐站、順便智能櫃或便利店）';
      var m4 = '返回購物車';
      var m5 = '營業時間';
      var m6 = '';
      var m7 = '門市提貨';
      var m8 = '請選擇送貨方式';
      var m9 = '搜尋';
      var all_stores = '所有門市';
    } else if (checkCurrentLang.indexOf('ch') >= 0) {
      var lang = 'zh-TW';
      var region = 'region_tc';
      var m1 = '送貨到指定地址';
      var m2 = '前往結帳';
      var m3 = '順豐提貨（順豐站、順便智能櫃或便利店）';
      var m4 = '返回購物車';
      var m5 = '營業時間';
      var m6 = '';
      var m7 = '門市提貨';
      var m8 = '請選擇送貨方式';
      var m9 = '搜尋';
      var all_stores = '所有門市';
    } else {
      var lang = 'en';
      var region = 'region_en';
      var m1 = 'Ship to your address';
      var m2 = 'Proceed to checkout'
      var m3 = 'Pick up at EF Lockers, S.F. Express stores, etc';
      var m4 = 'Return to cart';
      var m5 = 'Opening hours';
      var m6 = '';
      var m7 = 'Store Pickup';
      var m8 = 'Please select a shipping method';
      var m9 = 'Search';
      var all_stores = 'All Stores';
    }

    // Set input name is checkout
    if ($("*[name='checkout']").length) {
      console.log(1);
      showSfBtn = true;
    }

    // Set link with "checkout" text
    if ($("a[href*='checkout']").length) {
      showSfBtn = $("a[href*='checkout']").is(function () {
        let href = $(this).attr('href');
        return href.includes('/checkout') && !href.includes('checkout_url');
      });
    }

    // Set form submit button
    $("form").each(function () {
      var action = $(this).attr('action');
      if (action !== undefined) {
        if (action.includes("checkout")) {
          console.log(3);
          showSfBtn = true;
        }
      }
    });

    // Fix shella theme product detail page add to cart button
    $(".js-product-button-add-to-cart").click(function () {
      setTimeout(showSfBntton, 1500);
    });

    if (showSfBtn) {
      showSfBntton();
    }

    // For Buluukr theme
    if ($(".button-checkout").length) {
      showSfBntton();
    }

    function showSfBntton() {
      // Remove hidden input checkout
      $("*[name='checkout'][type=hidden]").remove();

      // Set sfexpress checkout button
      $("*[name='checkout']").prop({ type: "button" });
      $("*[name='checkout']").attr("href", "#");
      $("*[name='checkout']").css('display', 'inline-block');
      //Remove name checkout
      $("*[name='checkout']").addClass("sfexpress-checkout-btn");
      $("*[name='checkout']").prop("disabled", false);
      $("*[name='checkout']").removeAttr('name');

      // Set Buluukr checkout button
      $(".button-checkout").prop({ type: "button" });
      $(".button-checkout").css('display', 'inline-block');
      $(".button-checkout").attr("onclick", "").unbind("click");
      $(".button-checkout").addClass("sfexpress-checkout-btn");

      // Set langyatech checkout button
      $('#checkout').removeClass('cart__checkout-button');
      $('#checkout').removeAttr('id');

      // Set link with "checkout" text
      $("a[href*='checkout']").addClass("sfexpress-checkout-btn").attr("href", "#");

      // Set form submit button
      $("form").each(function () {
        var action = $(this).attr('action');
        if (action !== undefined) {
          if (action.includes("checkout")) {
            $(this).find('input[type=submit]').prop({ type: "button" }).addClass("sfexpress-checkout-btn");
          }
        }
      });

      // Check sorra mart theme don't run prevent drawer cannot add price in th checkout button
      if (!$("body").hasClass("aos-initialized")) {
        // Clone sfexpress checkout button to remove other theme or plugin affect
        $('.sfexpress-checkout-btn').wrap('<div class="regenerate-sfexpress-checkout"></div>');
        $(".regenerate-sfexpress-checkout").each(function () {
          $(this).find('.sfexpress-checkout-btn').clone().appendTo($(this));
          $(this).find('.sfexpress-checkout-btn:first').remove();
          $(this).contents().unwrap();
        });
      }

      // Click checkout button
      $(document).on('click', '.sfexpress-checkout-btn', function () {
        showLocalPickup();
      });
    }

    function showLocalPickup() {
      if ($("#localpickup").length == 0) {
        loadContent(store);

        // Disable elegantbeauty site popup
        $('.mfp-wrap').hide();
        $('.mfp-bg').hide();
      } else {
        $("#localpickup").attr('style', "display: block !important;");

        // Fix Cascade theme cannot open sf express popup again
        $("#localpickup").removeAttr("inert");
      }

      //Remove drawer
      $(".drawer").addClass('sf-hide');

      // Click close drawer to fix sorra mart theme drawer cart cannot scroll sfexpress app
      $(".drawer__close[data-drawer-toggle='drawer-cart']").trigger("click");
    }

    function loadContent(store) {
      var url = site_url + '/scripts/get_content.php?shop=' + store + '&lang=' + lang;

      $.ajax({
        type: 'get',
        url: url,
        success: function (res) {
          data = res['result'];
          storePickupData = res['storePicupResult'];
          main(data, storePickupData);
        }
      });
    }

    function main(data, storePickupData) {
      $('head').append('<link rel="stylesheet" type="text/css" href="https://shop.ysd.hk/apps/sfexpress/css/style.css">');

      var rsProvince = "HK";

      $("*.sfexpress-checkout-btn").prop({ type: "button" });
      $("*.sfexpress-checkout-btn").css('display', 'inline-block');

      $("#localpickup").remove();

      $("body").append('<div id="localpickup" class="normal-label"><div id="checkout-container"><div class="back-container"><a id="back-btn" class="step__footer__previous-link-content m4 back-btn"><i class="arrow left back-arrow"></i><label class="back-text">' + m4 + '</label></a></div><div class="select-method-container app-description">' + m8 + '</div></div></div>');

      //Display
      $("#localpickup").attr('style', "display: block !important;");

      //Store pickup
      if (storePickupData.length !== 0) {
        $("#checkout-container").append('<div id="sp-select-checkout" class="select-conatainer"><div class="ui-heading ui-heading-open"><div class="header-left shipping-title-3">' + m7 + '</div><div class="header-right"><i class="arrow right dropdown-arrow"></i></div></div><div class="dropdown-container"><div id="sp-select-address"><div id="sp-district-container" class="sp-select-address"></div><div class="sp-result-container"></div><div class="checout-btn-container"><p class="shipping-title-4"></p><p class="shipping-title-5"></p><button id="sp-checkout-btn" class="sf-each-checkout-btn">' + m2 + '</button></div></div></div></div>');

        var selectSPRegion = $("<select></select>").attr("id", "sp-cart-region").attr("name", "sp-cart-region").attr("class", "ui-select");
        var selectSPDistrict = $("<select></select>").attr("id", "sp-cart-district").attr("name", "sp-cart-district").attr("class", "ui-select");

        //Fix Infinite Product Options App
        fixInfiniteProductOptionsApp();

        //Setup First time
        selectSPDistrict.append($("<option></option>").attr("value", "all").text(all_stores));

        $.each(storePickupData.district, function (key, value) {
          selectSPDistrict.append($("<option></option>").attr("value", key).text(key));
        });
        $("#sp-district-container").append(selectSPDistrict);

        $(".sp-result-container").append('<div id="sp-address-result"></div>');

        //get first district key
        for (spFstDis in storePickupData.district) {
          $.each(storePickupData.district[spFstDis].detail, function (key, value) {
            $("#sp-address-result").append('<div class="sp-each-result"><div class="each-result-left"><input id="result-' + value.n + '" type="radio" name="sp-result" class="sp-address-result-btn" data-region="' + value.r + '" value="' + value.n + ' ' + value.ads + '"></div><div class="each-result-right" for="result-' + value.n + '"><div class="address-result-code">' + value.n + '</div><div class="address-result-address">' + value.ads + '</div><div class="address-result-info">' + nl2br(value.i) + '</div></div></div>');
          });
        }

        setSpCheckoutUrl();

        $("#sp-cart-district").on('change', function () {
          spLoadResult();
        });

        function spLoadResult() {
          var districtIndex = $("#sp-cart-district option:selected").val();

          // //Remove current option
          $('#sp-address-result').remove();
          $(".sp-result-container").append('<div id="sp-address-result"></div>');

          if (districtIndex == "all") {
            for (spFstDis in storePickupData.district) {
              $.each(storePickupData.district[spFstDis].detail, function (key, value) {
                $("#sp-address-result").append('<div class="sp-each-result"><div class="each-result-left"><input id="result-' + value.n + '" type="radio" name="sp-result" class="sp-address-result-btn" data-region="' + value.r + '" value="' + value.n + ' ' + value.ads + '"></div><div class="each-result-right" for="result-' + value.n + '"><div class="address-result-code">' + value.n + '</div><div class="address-result-address">' + value.ads + '</div><div class="address-result-info">' + nl2br(value.i) + '</div></div></div>');
              });
            }
          } else {
            $.each(storePickupData.district[districtIndex].detail, function (key, value) {
              $("#sp-address-result").append('<div class="sp-each-result each-result"><div class="each-result-left"><input id="result-' + value.n + '" type="radio" name="sp-result" class="sp-address-result-btn" data-region="' + value.r + '" value="' + value.n + ' ' + value.ads + '"></div><div class="each-result-right" for="result-' + value.n + '"><div class="address-result-code">' + value.n + '</div><div class="address-result-address">' + value.ads + '</div><div class="address-result-info">' + nl2br(value.i) + '</div></div></div>');
            });
          }

          setSpCheckoutUrl();
        }

        function setSpCheckoutUrl() {
          //Set store pickup checkout url
          $(".sp-address-result-btn:first").attr('checked', true);
          spCheckSelectResult();

          $('.sp-address-result-btn').change(function () {
            spCheckSelectResult();
          });

          $(".sp-each-result").click(function () {
            $(".sp-address-result-btn").prop('checked', false);
            $(this).find(".sp-address-result-btn").prop('checked', true);
            spCheckSelectResult();
          });
        }

        function spCheckSelectResult() {
          var regionIndex = $('.sp-address-result-btn:checked').data('region');
          var districtIndex = $("#sp-cart-district option:selected").val();
          var resultIndex = $('.sp-address-result-btn:checked').val();

          if (regionIndex && districtIndex && resultIndex) {

            //Fix Infinite Product Options App
            if (typeof window.hulkappsCheckout !== "undefined" && $subTotal > 0) {
              $("#sp-checkout-btn").click(function () {
                var storage_code = localStorage.getItem('discount_code');
                $.getJSON('/cart.js', function (cart) {
                  window.hulkapps.cart = cart;
                  $.ajax({
                    type: "POST",
                    url: window.hulkapps.po_url + "/store/create_draft_order",
                    data: { cart_json: window.hulkapps, store_id: window.hulkapps.store_id, discount_code: storage_code, cart_collections: JSON.stringify(window.hulkapps.cart_collections) },
                    crossDomain: true,
                    success: function (res) {
                      var province = getProvince(regionIndex);

                      if (typeof res == "string") {
                        res = encodeURI(res + '?step=contact_information&checkout[pick_up_in_store][selected]=false&checkout[shipping_address][address1]=' + resultIndex + '&checkout[shipping_address][city]=' + districtIndex + '&checkout[shipping_address][country]=Hong Kong&checkout[shipping_address][province]=' + province);
                        window.location.href = res;
                      } else {
                        window.location.href = encodeURI('/' + langpath + 'checkout?step=contact_information&checkout[pick_up_in_store][selected]=false&checkout[shipping_address][address1]=' + resultIndex + '&checkout[shipping_address][city]=' + districtIndex + '&checkout[shipping_address][country]=Hong Kong&checkout[shipping_address][province]=' + province);
                      }
                      localStorage.removeItem('discount_code');
                    }
                  });
                });
              });
            } else {
              var province = getProvince(regionIndex);

              var checkoutUrl = encodeURI('/' + langpath + 'checkout?step=contact_information&checkout[pick_up_in_store][selected]=false&checkout[shipping_address][address1]=' + resultIndex + '&checkout[shipping_address][city]=' + districtIndex + '&checkout[shipping_address][country]=Hong Kong&checkout[shipping_address][province]=' + province);
              $('#sp-checkout-btn').data('link', checkoutUrl);
              $('#sp-checkout-btn').data('address', resultIndex);
            }
          }
        }
      }

      //SF Express
      if (data.length !== 0) {
        $("#checkout-container").append('<div id="select-checkout" class="select-conatainer"><div class="ui-heading ui-heading-open"><div class="header-left shipping-title-2">' + m3 + '</div><div class="header-right"><i class="arrow right dropdown-arrow"></i></div></div><div class="dropdown-container"><div id="select-address"><div id="region-container" class="select-address first-address"></div><div id="district-container" class="select-address second-address"></div><div id="type-container" class="select-address third-address"></div><div id="search-container" class="select-address search-address"><input type="search" class="input-field" name="keyword" placeholder ="' + m9 + '"></div><div class="result-container"></div><div class="checout-btn-container"><p class="shipping-title-4"></p><p class="shipping-title-5"><p class="shipping-title-6" style="color:red;font-weight:bold;"></p><button id="sf-checkout-btn" class="sf-each-checkout-btn">' + m2 + '</button></<div></div></div></div></div>');

        var selectRegion = $("<select></select>").attr("id", "cart-region").attr("name", "cart-region").attr("class", "ui-select");
        var selectDistrict = $("<select></select>").attr("id", "cart-district").attr("name", "cart-district").attr("class", "ui-select");
        var selectType = $("<select></select>").attr("id", "cart-type").attr("name", "cart-type").attr("class", "ui-select");

        //Fix Infinite Product Options App
        fixInfiniteProductOptionsApp();

        setSelectContent();

        // Search keyword
        $(".input-field").on("input", function () {
          var keyword = this.value;

          $("#region-container").hide();
          $("#district-container").hide();
          $("#type-container").hide();
          $("#localpickup .select-address").css('width', '100%');

          if (keyword == "") {
            $("#region-container").show();
            $("#district-container").show();
            $("#type-container").show();
            $("#localpickup .select-address").css('width', '25%');

            // reset
            setSelectContent();
          } else {
            loadSearchContent(store, keyword);
          }
        });

        function loadSearchContent(store, keyword) {
          // Set the delay for call ajax
          clearTimeout(window.timer);
          window.timer = setTimeout(function () {
            var url = site_url + '/scripts/get_search_content.php?shop=' + store + '&lang=' + lang + '&keyword=' + keyword;

            $.ajax({
              type: 'get',
              url: url,
              success: function (res) {
                searchData = res['result'];
                loadSearchResult();
              },
            });
          }, 200);
        }

        function setSelectContent() {
          //Remove current option
          $('#address-result').remove();
          $(".result-container").append('<div id="address-result"></div>');

          //Clear all select address
          $("#region-container").find('option').remove();
          $("#district-container").find('option').remove();
          $("#type-container").find('option').remove();

          //Setup First time
          $.each(data, function (key, value) {
            selectRegion.append($("<option></option>").attr("value", key).text(key));
          });
          $("#region-container").append(selectRegion);

          //get first region key
          for (fstReg in data) {
            break;
          }

          $.each(data[fstReg].district, function (key, value) {
            selectDistrict.append($("<option></option>").attr("value", key).text(key));
          });
          $("#district-container").append(selectDistrict);

          //get first district key
          for (fstDis in data[fstReg].district) {
            break;
          }

          $.each(data[fstReg].district[fstDis].type, function (key, value) {
            selectType.append($("<option></option>").attr("value", key).text(key));
          });
          $("#type-container").append(selectType);

          //get first district key
          for (fstType in data[fstReg].district[fstDis].type) {
            break;
          }

          $(".result-container").append('<div id="address-result"></div>');

          $.each(data[fstReg].district[fstDis].type[fstType].detail, function (key, value) {
            openHour = setOpenHour(value.t1, value.t2, value.t3);

            var typeIndex = $("#cart-type option:selected").val();
            var typeText = $("#cart-type option:selected").text();

            $("#address-result").append('<div class="each-result"><div class="each-result-left"><input id="result-' + value.c + '" type="radio" name="result" class="address-result-btn" value="' + value.c + ' ' + value.ads + '" data-regionindex = "' + fstReg + '" data-districtindex = "' + fstDis + '" data-typeindex = "' + fstType + '"></div><div class="each-result-right" for="result-' + value.c + '"><div class="address-result-code">' + typeText + ' ' + value.c + '</div><div class="address-result-address">' + value.ads + '</div><div class="address-result-hour">' + m5 + ':<br>' + openHour + '</div></div></div>');
          });

          setCheckoutUrl();
        }

        $("#cart-region").on('change', function () {
          loadDistrict();
        });

        $("#cart-district").on('change', function () {
          loadType();
        });

        $("#cart-type").on('change', function () {
          loadResult();
        });

        function loadDistrict() {
          var regionIndex = $("#cart-region option:selected").val();

          //Remove current option
          $('#cart-district').empty();

          $.each(data[regionIndex].district, function (key, value) {
            selectDistrict.append($("<option></option>").attr("value", key).text(key));
            $("#district-container").append(selectDistrict);
          });

          //load type
          loadType();
        }

        function loadType() {
          var regionIndex = $("#cart-region option:selected").val();
          var districtIndex = $("#cart-district option:selected").val();

          //Remove current option
          $('#cart-type').empty();

          $.each(data[regionIndex].district[districtIndex].type, function (key, value) {
            selectType.append($("<option></option>").attr("value", key).text(key));
            $("#type-container").append(selectType);

            //load result
            loadResult();
          });
        }

        function loadResult() {
          var regionIndex = $("#cart-region option:selected").val();
          var districtIndex = $("#cart-district option:selected").val();
          var typeIndex = $("#cart-type option:selected").val();
          var typeText = $("#cart-type option:selected").text();

          // //Remove current option
          $('#address-result').remove();
          $(".result-container").append('<div id="address-result"></div>');

          $.each(data[regionIndex].district[districtIndex].type[typeIndex].detail, function (key, value) {
            openHour = setOpenHour(value.t1, value.t2, value.t3);

            $("#address-result").append('<div class="each-result"><div class="each-result-left"><input id="result-' + value.c + '" type="radio" name="result" class="address-result-btn" value="' + value.c + ' ' + value.ads + '" data-regionindex = "' + regionIndex + '" data-districtindex = "' + districtIndex + '" data-typeindex = "' + typeIndex + '"></div><div class="each-result-right" for="result-' + value.c + '"><div class="address-result-code">' + typeText + ' ' + value.c + '</div><div class="address-result-address">' + value.ads + '</div><div class="address-result-hour">' + m5 + ':<br>' + openHour + '</div></div></div>');
          });

          setCheckoutUrl();
        }

        function loadSearchResult() {
          // //Remove current option
          $('#address-result').remove();
          $(".result-container").append('<div id="address-result"></div>');

          for (var regionIndex in searchData) {
            for (var districtIndex in searchData[regionIndex].district) {
              for (var typeIndex in searchData[regionIndex].district[districtIndex].type) {
                $.each(searchData[regionIndex].district[districtIndex].type[typeIndex].detail, function (key, value) {
                  openHour = setOpenHour(value.t1, value.t2, value.t3);

                  $("#address-result").append('<div class="each-result"><div class="each-result-left"><input id="result-' + value.c + '" type="radio" name="result" class="address-result-btn" value="' + value.c + ' ' + value.ads + '" data-regionindex = "' + regionIndex + '" data-districtindex = "' + districtIndex + '" data-typeindex = "' + typeIndex + '"></div><div class="each-result-right" for="result-' + value.c + '"><div class="address-result-code">' + typeIndex + ' ' + value.c + '</div><div class="address-result-address">' + value.ads + '</div><div class="address-result-hour">' + m5 + ':<br>' + openHour + '</div></div></div>');
                });
              }
            }
          }

          setCheckoutUrl();
        }

        function setCheckoutUrl() {
          // Set checkout url
          $(".address-result-btn:first").attr('checked', true);
          checkSelectResult();

          $('.address-result-btn').change(function () {
            checkSelectResult();
          });

          $(".each-result").click(function () {
            $(".address-result-btn").prop('checked', false);
            $(this).find(".address-result-btn").prop('checked', true);
            checkSelectResult();
          });
        }

        function checkSelectResult() {
          var resultIndex = $('.address-result-btn:checked').val();
          var regionIndex = $('.address-result-btn:checked').data("regionindex");
          var districtIndex = $('.address-result-btn:checked').data("districtindex");
          var typeIndex = $('.address-result-btn:checked').data("typeindex");

          if (regionIndex && districtIndex && typeIndex && resultIndex) {

            if (lang == 'en') {
              value_type = data[regionIndex].district[districtIndex].type[typeIndex].type_en;
            } else if (lang == 'zh-TW') {
              value_type = data[regionIndex].district[districtIndex].type[typeIndex].type_tc;
            }

            //Fix Infinite Product Options App
            if (typeof window.hulkappsCheckout !== "undefined" && $subTotal > 0) {
              $("#sf-checkout-btn").click(function () {
                var storage_code = localStorage.getItem('discount_code');
                $.getJSON('/cart.js', function (cart) {
                  window.hulkapps.cart = cart;
                  $.ajax({
                    type: "POST",
                    url: window.hulkapps.po_url + "/store/create_draft_order",
                    data: { cart_json: window.hulkapps, store_id: window.hulkapps.store_id, discount_code: storage_code, cart_collections: JSON.stringify(window.hulkapps.cart_collections) },
                    crossDomain: true,
                    success: function (res) {
                      var province = getProvince(regionIndex);

                      if (typeof res == "string") {
                        if (regionIndex == "Macau" || regionIndex == "澳門" || regionIndex == "澳門區") {
                          res = encodeURI(res + '?step=contact_information&checkout[pick_up_in_store][selected]=false&checkout[shipping_address][address1]=' + typeIndex + ' ' + resultIndex + '&checkout[shipping_address][city]=Macao&checkout[shipping_address][country]=Macao&checkout[shipping_address][zip]=999078');
                        } else {
                          res = encodeURI(res + '?step=contact_information&checkout[pick_up_in_store][selected]=false&checkout[shipping_address][address1]=' + typeIndex + ' ' + resultIndex + '&checkout[shipping_address][city]=' + districtIndex + '&checkout[shipping_address][country]=Hong Kong&checkout[shipping_address][province]=' + province);
                        }
                        window.location.href = res;
                      } else {
                        if (regionIndex == "Macau" || regionIndex == "澳門" || regionIndex == "澳門區") {
                          window.location.href = encodeURI('/' + langpath + 'checkout?step=contact_information&checkout[pick_up_in_store][selected]=false&checkout[shipping_address][address1]=' + typeIndex + ' ' + resultIndex + '&checkout[shipping_address][city]=Macao&checkout[shipping_address][country]=Macao&checkout[shipping_address][zip]=999078');
                        } else {
                          window.location.href = encodeURI('/' + langpath + 'checkout?step=contact_information&checkout[pick_up_in_store][selected]=false&checkout[shipping_address][address1]=' + typeIndex + ' ' + resultIndex + '&checkout[shipping_address][city]=' + districtIndex + '&checkout[shipping_address][country]=Hong Kong&checkout[shipping_address][province]=' + province);
                        }
                      }
                      localStorage.removeItem('discount_code');
                    }
                  });
                });
              });
            } else {
              var province = getProvince(regionIndex);

              if (regionIndex == "Macau" || regionIndex == "澳門" || regionIndex == "澳門區") {
                var checkoutUrl = encodeURI('/' + langpath + 'checkout?step=contact_information&checkout[pick_up_in_store][selected]=false&checkout[shipping_address][address1]=' + typeIndex + ' ' + resultIndex + '&checkout[shipping_address][city]=Macao&checkout[shipping_address][country]=Macao&checkout[shipping_address][zip]=999078');

                $('#sf-checkout-btn').data('link', checkoutUrl);
                $('#sf-checkout-btn').data('address', typeIndex + ' ' + resultIndex);
              } else {
                var checkoutUrl = encodeURI('/' + langpath + 'checkout?step=contact_information&checkout[pick_up_in_store][selected]=false&checkout[shipping_address][address1]=' + typeIndex + ' ' + resultIndex + '&checkout[shipping_address][city]=' + districtIndex + '&checkout[shipping_address][country]=Hong Kong&checkout[shipping_address][province]=' + province);

                $('#sf-checkout-btn').data('link', checkoutUrl);
                $('#sf-checkout-btn').data('address', typeIndex + ' ' + resultIndex);
              }
            }
          }
        }

        function setOpenHour(value_time_hr_1_5, value_time_hr_6, value_time_hr_7) {
          var result = "";

          if ((value_time_hr_1_5 == value_time_hr_6) && (value_time_hr_1_5 == value_time_hr_7)) {
            if (lang == 'en') {
              result = 'Mon to Sun & Public Holiday (24 hours)';
            } else if (lang == 'zh-TW') {
              result = '星期一至日及公眾假期二十四小時';
            }
          } else if ((value_time_hr_1_5 == value_time_hr_6) && (value_time_hr_1_5 != value_time_hr_7)) {
            if (lang == 'en') {
              result = 'Mon to Sat (' + value_time_hr_1_5 + ')<br>Sun & Public Holiday (' + value_time_hr_7 + ')';
            } else if (lang == 'zh-TW') {
              result = '星期一至六：' + value_time_hr_1_5 + '<br>星期日及公眾假期：' + value_time_hr_7;
            }
          } else if ((value_time_hr_1_5 != value_time_hr_6) && (value_time_hr_1_5 != value_time_hr_7) && (value_time_hr_6 != value_time_hr_7)) {
            if (lang == 'en') {
              result = 'Mon to Fri (' + value_time_hr_1_5 + ')<br>Sat (' + value_time_hr_6 + '), Sun & Public Holiday (' + value_time_hr_7 + ')';
            } else if (lang == 'zh-TW') {
              result = '星期一至五：' + value_time_hr_1_5 + '<br>星期六：' + value_time_hr_6 + '，星期日及公眾假期：' + value_time_hr_7;
            }
          } else if ((value_time_hr_1_5 != value_time_hr_6) && (value_time_hr_6 == value_time_hr_7)) {
            if (lang == 'en') {
              result = 'Mon to Fri (' + value_time_hr_1_5 + ')<br>Sat, Sun & Public Holiday (' + value_time_hr_6 + ')';
            } else if (lang == 'zh-TW') {
              result = '星期一至五：' + value_time_hr_1_5 + '<br>星期六，星期日及公眾假期：' + value_time_hr_6;
            }
          }

          return result;
        }
      }

      //Normal checkout
      setNormalCheckout();

      function setNormalCheckout() {
        $("#checkout-container").append('<div id="normal-checkout" class="select-conatainer"><a id="normal-checkout-btn" href="/' + langpath + 'checkout/"><div class="ui-heading"><div class="header-left shipping-title-1">' + m1 + '</div><div class="header-right"><i class="arrow right dropdown-arrow"></i></div></div></a></div>');
      }

      $('.ui-heading-open').on('click', function () {
        if ($(this).attr('data-click-state') == 1) {
          $(this).attr('data-click-state', 0);
          $(this).find('.dropdown-arrow').removeClass('down');
          $(this).find('.dropdown-arrow').addClass('right');
          $(this).find('.dropdown-arrow').css({
            'border': 'solid black',
            'border-width': '0 1px 1px 0',
          });
          $(this).find('.header-left').css('color', '#000000');
          $(this).parent().find('.dropdown-container').hide();
        }
        else {
          $(this).attr('data-click-state', 1);
          $(this).find('.dropdown-arrow').removeClass('right');
          $(this).find('.dropdown-arrow').addClass('down');
          if (checkout_btn_bg_color != "") {
            var mainColor = checkout_btn_bg_color;
          } else {
            var mainColor = '#3f4eae';
          }
          $(this).find('.dropdown-arrow').css({
            'border': 'solid ' + mainColor,
            'border-width': '0 1px 1px 0',
          });
          $(this).find('.header-left').css('color', mainColor);
          $(this).parent().find('.dropdown-container').show();
        }
      });

      if (checkout_btn_bg_color != "") {
        $(".select-conatainer").css("border-left", "5px solid " + checkout_btn_bg_color);
        $(".shipping-title-4").css("color", checkout_btn_bg_color);
      }

      if (checkout_btn_bg_color != "" && checkout_btn_text_color != "") {
        $(".sf-each-checkout-btn").css({
          "cssText": "color: " + checkout_btn_text_color + " !important;",
          "background": checkout_btn_bg_color,
          "border": "1px solid " + checkout_btn_bg_color,
        });
      }

      if (sfexpress_copy_font_size != "" && sfexpress_copy_font_size != 0) {
        $(".shipping-title-4").css("font-size", sfexpress_copy_font_size + 'px');
      }

      if (lang == 'en') {
        if (app_description_en) {
          $(".app-description").text(app_description_en);
        }

        if (ship_address_en) {
          $(".shipping-title-1").text(ship_address_en);
        }

        if (sfexpress_stores_en) {
          $(".shipping-title-2").text(sfexpress_stores_en);
        }

        if (store_pickup_en) {
          $(".shipping-title-3").text(store_pickup_en);
        }

        if (sfexpress_copy_en) {
          $(".shipping-title-4").text(sfexpress_copy_en);
        }

        if (sfexpress_remark_en) {
          $(".shipping-title-5").text(sfexpress_remark_en);
        }
        if (default_sfexpress_copy_en) {
          $(".shipping-title-6").text(default_sfexpress_copy_en);
        }
      } else if (lang == 'zh-TW') {
        if (app_description_tc) {
          $(".app-description").text(app_description_tc);
        }

        if (ship_address_tc) {
          $(".shipping-title-1").text(ship_address_tc);
        }

        if (sfexpress_stores_tc) {
          $(".shipping-title-2").text(sfexpress_stores_tc);
        }

        if (store_pickup_tc) {
          $(".shipping-title-3").text(store_pickup_tc);
        }

        //if (sfexpress_copy_tc) {
        //  $(".shipping-title-4").text(sfexpress_copy_tc);
        //}

        if (sfexpress_remark_tc) {
          $(".shipping-title-5").text(sfexpress_remark_tc);
        }
        if (default_sfexpress_copy_tc) {
          $(".shipping-title-6").text(default_sfexpress_copy_tc);
        }
      }

      $("#back-btn").click(function () {
        $("#localpickup").attr('style', "display: none !important;");

        //Show drawer
        $(".drawer").removeClass('sf-hide');
      });

      $('#sf-checkout-btn').click(function () {
        checkout($(this));
      });

      $('#sp-checkout-btn').click(function () {
        checkout($(this));
      });

      function checkout(btnObj) {
        var address = btnObj.data('address');
        copyToClipboard(address);

        //Support accounts are required
        setCookie('sfCheckoutLink', btnObj.data("link"), '1');
        // Replace the link from /checkout to /cart
        var link = btnObj.data("link");
        link = link.replace("/checkout", "/cart");
        console.log('sfexpress.js link', link);
        // Update #mini-cart action
        $('#mini-cart').attr('action', link);
        if(discountNinja){
          console.log('discountNinja');
          document.dispatchEvent(new CustomEvent('la:dn:checkout:initiate'));
        }else{
          console.log('no discountNinja');
          document.location.href = link;
        }


        // document.location.href = btnObj.data("link");

      }

      function copyToClipboard(text) {
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(text).select();
        document.execCommand("copy");
        $temp.remove();
      }

      function getProvince(index) {
        var province = "";
        if (index == 'Hong Kong Island' || index == '香港') {
          province = 'HK';
        } else if (index == 'Kowloon' || index == '九龍') {
          province = 'KL';
        } else if (index == 'New Territories' || index == '新界') {
          province = 'NT';
        }

        return province;
      }

      function fixInfiniteProductOptionsApp() {
        //check subTotal
        $subTotal = 0;
        $('[data-cart-item-property-value]').each(function (index, value) {
          var text = $(this).text();
          var n = text.includes("$");
          var regex = /[+-]?\d+(\.\d+)?/g;
          if (n) {
            var subPrice = Number(text.replace(/[^0-9\.]+/g, ""));

            var matchs = text.match(regex).map(function (v) { return parseFloat(v); });
            matchs.forEach(function (val, index) {
              $subTotal += val;
            });
          }
        });

        if (typeof window.hulkappsCheckout !== "undefined") {
          //rewrite hulkappsCheckout function
          window.hulkappsCheckout = function () { }
        }

        if (typeof window.hulkappsCheckout !== "undefined" && $subTotal > 0) {
          $("#normal-checkout-btn").attr("href", "#");

          $("#normal-checkout-btn").click(function () {
            var storage_code = localStorage.getItem('discount_code');
            $.getJSON('/cart.js', function (cart) {
              window.hulkapps.cart = cart;
              $.ajax({
                type: "POST",
                url: window.hulkapps.po_url + "/store/create_draft_order",
                data: { cart_json: window.hulkapps, store_id: window.hulkapps.store_id, discount_code: storage_code, cart_collections: JSON.stringify(window.hulkapps.cart_collections) },
                crossDomain: true,
                success: function (res) {
                  if (typeof res == "string") {
                    window.location.href = res
                  } else {
                    window.location.href = '/' + langpath + '/checkout/';
                  }
                  localStorage.removeItem('discount_code');
                }
              });
            });
          });
        }
      }

      function nl2br(str, is_xhtml) {
        if (str != null) {
          var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
          return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        }

        return "";
      }
    }

    //Cookie
    function setCookie(key, value, expiry) {
      var expires = new Date();
      expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
      document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
    }

    function getCookie(key) {
      var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
      return keyValue ? keyValue[2] : null;
    }

    function eraseCookie(key) {
      var keyValue = getCookie(key);
      setCookie(key, keyValue, '-1');
    }

    function setLangPath(secondLevelLocation) {
      var langpath = '';

      switch (secondLevelLocation) {
        case 'zh-tw':
          langpath = 'zh-TW/';
          break;
        case 'zh-hk':
          langpath = 'zh-TW/';
          break;
        case 'zh-cn':
          langpath = 'zh-CN/';
          break;
        case 'zh':
          langpath = 'zh/';
          break;
        case 'tw':
          langpath = 'zh-TW/';
          break;
        case 'hk':
          langpath = 'zh-TW/';
          break;
        case 'cn':
          langpath = 'zh-CN/';
          break;
        case 'ch':
          langpath = 'zh-TW/';
          break;
        case 'en':
          langpath = 'en/';
          break;
        default:
          langpath = '';
      }

      return langpath;
    }

    //Detect element has been added to DOM
    function onElementInserted(containerSelector, elementSelector, callback) {
      var onMutationsObserved = function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length) {
            var elements = $(mutation.addedNodes).find(elementSelector);
            for (var i = 0, len = elements.length; i < len; i++) {
              callback(elements[i]);
            }
          }
        });
      };

      var target = $(containerSelector)[0];
      var config = { childList: true, subtree: true };
      var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
      var observer = new MutationObserver(onMutationsObserved);
      observer.observe(target, config);
    }

    onElementInserted('body', '*[name="checkout"]', function (element) {
      init();
    });

    // For Responsive theme product quick shop checkout button
    onElementInserted('body', 'div.cart-notification__checkout .action_button', function (element) {
      init();
    });

    // For Buluukr theme
    onElementInserted('body', '.button-checkout', function (element) {
      init();
    });

    // Click add to cart in Parallax theme product detail page
    $(".atc-btn-container .add_to_cart").click(function () {
      setTimeout(init, 1000);
    });
  });
}